import { render, staticRenderFns } from "./PlayerCombatStarEvent.vue?vue&type=template&id=222effe8&scoped=true&"
import script from "./PlayerCombatStarEvent.vue?vue&type=script&lang=js&"
export * from "./PlayerCombatStarEvent.vue?vue&type=script&lang=js&"
import style0 from "./PlayerCombatStarEvent.vue?vue&type=style&index=0&id=222effe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222effe8",
  null
  
)

export default component.exports